import React from 'react';
import './Optionalfunct.css';
import bottomImage from '../../../imgs/optionfunct.webp'; 

const Optionalfunct = () => {
  return (
    <div className="Optional-container">
      <h2>Optional Functions</h2>

      <div className="Optionalf-section">
        <div className="Optionalf-card"data-aos="fade-down-right">
          <h3>Water Cooling Robot</h3>
          <p>Saves the cooling time in mould, which reduces the cycle time.</p>
        </div>

        <div className="Optionalf-card"data-aos="fade-down-left">
          <h3>Protective Top Cover</h3>
          <p>Improves sanitary requirements and thermal control.</p>
        </div>
      </div>

      <div className="bottom-img">
        <img src={bottomImage} alt="Bottom Display" />
      </div>
    </div>
  );
};

export default Optionalfunct;
